<template>
<div id="website" class="flex-c">
    <van-image v-for="(item, index) in imgList" :key="index" :src="item.url" @click="enterWebsite(index)" class="wrap flex-self-ctr" />
</div>
</template>

<script>
export default {
    data() {
        return {
            imgList: [{
                url: require('@/assets/servier_china.png')
            }, {
                url: require('@/assets/servier_groups.png')
            }, {
                url: require('@/assets/servier.png')
            }],
            websiteUrl: []
        }
    },
    created() {},
    methods: {
        enterWebsite(val) {
            switch (parseInt(val)) {
                case 0:
                    this.$router.push('china');
                    break;
                case 1:
                    this.$router.push('groups');
                    break;
                case 2:
                    window.location.href = 'https://www.servier.com.cn';
                    break;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#website {
    padding-top: 30px;
    .wrap{
        width: 690px;
        height: 282px;
        margin-bottom: 30px;
    }
}
</style>
